import config from "../config.json";
import {useEffect, useRef, useState} from 'react';
import {loadModules} from 'esri-loader';
import getInfoString from '../getInfoString';
import getAdrCode from '../getAdrCode';


function MyMap({mapview,iFrameDetection,setPendingLocation,setStatus,poisLayer,basemapCarto,basemapImagery,location,setLocation,signal,controller,pinLayer,locationCoords}){
    const map = useRef(null);
    const myLocationLayer = useRef(null);
    const myLocationMarker = useRef({
        type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
        path:"M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z",
        size:24,
        xoffset:0,
        yoffset:12,
        color:[0, 80, 127],
        outline:{
            color:[255,255,255],
            width:"1px"
        }
    });
    const myLocationGraphic = useRef(null);
    // const pinLayerImagery = useRef(null);
    const zoomWidget = useRef(null);
    const basemapGallery = useRef(null);
    const expandBasemap = useRef(null);
    const pinPoint = useRef({
        type: "point",  // autocasts as new Point()
    });
    const pin = useRef({
        type: "picture-marker",  // autocasts as new SimpleMarkerSymbol()
        url:process.env.PUBLIC_URL + "/location_map.png",
        height:62,
        width:62,
    });
    const searchWidget = useRef(null);
    const locateBtn = useRef(null);
    const [copiedToClipboard,setCopiedToClipboard]=useState(false);
    useEffect(()=>{
        if(!map.current){
            const options = {
                center: [9.394774349084965,34.14100072262128], // Longitude, latitude
                zoom: 3, // Zoom level
            }
            loadModules([
            "esri/WebMap",
            "esri/views/MapView",
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/widgets/Search",
            "esri/widgets/Locate",
            "esri/widgets/Zoom",
            "esri/widgets/BasemapGallery",
            "esri/widgets/Expand"]).then(([WebMap,Mapview,GraphicsLayer,Graphic,Search,Locate,Zoom,BasemapGallery,Expand]) =>{
                const popupTrailheads = {
                    "title": "Trailhead",
                    "content": "<b>Trail:</b> {TRL_NAME}<br><b>City:</b> {CITY_JUR}<br><b>Cross Street:</b> {X_STREET}<br><b>Parking:</b> {PARKING}<br><b>Elevation:</b> {ELEV_FT} ft"
                  }
                
                map.current = new WebMap({
                    basemap:basemapCarto
                })


                mapview.current = new Mapview({
                    map: map.current,
                    ...options,
                    container: "map", // Div element
                    constraints:{
                        minZoom:3
                    },
                    ui:{
                        components:[]
                    },
                    popup:{
                        viewModel:{
                            includeDefaultActions:false
                        },
                        visibleElements:{
                            closeButton:false,
                            featureNavigation:false,
                        },
                        dockEnabled:false,
                        dockOptions:{
                            breakpoint:false,
                            buttonEnabled:false
                        },
                        alignment:"bottom-center"
                    }
                });
                zoomWidget.current = new Zoom({
                    view:mapview.current,
                    container:"zoom"
                });

                searchWidget.current = new Search({
                    view:mapview.current,
                    sources:[{
                        url: config.geocoder,
                        singleLineFieldName: "SingleLine",
                        name: "Custom Geocoding Service",
                        placeholder: "Cherchez votre adresse",
                        maxResults: 1,
                        maxSuggestions: 6,
                        suggestionsEnabled: true,
                        minSuggestCharacters: 0
                    }],
                    popupEnabled:false,
                    includeDefaultSources:false,
                    container:"search"
                })

                locateBtn.current = new Locate({
                    view: mapview.current,   // Attaches the Locate button to the view
                    graphic: new Graphic({
                      symbol: myLocationMarker.current, // overwrites the default symbol used for the
                      // graphic placed at the location of the user when found
                      popupEnabled:false
                    }),
                    container:"locate",
                    iconClass:"esri-icon-locate",
                    popupEnabled:false
                });
                locateBtn.current.on("locate",()=>{
                    myLocationLayer.current.removeAll();
                })
                basemapGallery.current = new BasemapGallery({
                    view: mapview.current,
                    container: document.createElement("div"),
                    source:[basemapCarto,basemapImagery]
                });
                expandBasemap.current = new Expand({
                    view: mapview.current,
                    content: basemapGallery.current.domNode,
                    container: "expand",
                    iconClass: "esri-icon-layers"
                })

                map.current.add(poisLayer.current);
                pinLayer.current = new GraphicsLayer();

                map.current.add(pinLayer.current);
                mapview.current.goTo(options);
                mapview.current.when(()=>{
                    if(navigator.geolocation){
                        navigator.geolocation.getCurrentPosition((position)=>{
                            options.center = [position.coords.longitude,position.coords.latitude];
                            options.zoom = 11;
                            myLocationMarker.current = {
                                type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
                                path:"M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z",
                                size:24,
                                xoffset:0,
                                yoffset:12,
                                color:[0, 80, 127],
                                outline:{
                                    color:[255,255,255],
                                    width:"1px"
                                }
                            };
                            myLocationLayer.current = new GraphicsLayer();
                            map.current.add(myLocationLayer.current);
                            myLocationGraphic.current = new Graphic({
                                geometry:{
                                    type: "point",  // autocasts as new Point()
                                    latitude:position.coords.latitude,
                                    longitude:position.coords.longitude
                                },
                                symbol: myLocationMarker.current
                            });
                            myLocationLayer.current.add(myLocationGraphic.current);
                            setTimeout(()=>mapview.current.goTo(options),500);
                        })
    
                    }
                })

                mapview.current.on("click", function(event){
                    setLocation(null);
                    pinLayer.current.removeAll();
                    pinPoint.current.latitude=event.mapPoint.latitude;
                    pinPoint.current.longitude=event.mapPoint.longitude;
                    let pinGraphic = new Graphic({
                        geometry: pinPoint.current,
                        symbol: pin.current
                    });         
                    pinLayer.current.add(pinGraphic);
                    setPendingLocation({latitude:event.mapPoint.latitude, longitude:event.mapPoint.longitude});
                });

            });
        }
    },[]);

    useEffect(()=>{
        if(mapview.current){
            if(location){
                const msg = getInfoString(iFrameDetection , location);
                const adrCode = getAdrCode(locationCoords);
                mapview.current.popup.open({
                    title: '',
                    content:'<div class="widget-popup"><h1>'+msg+'</h1> <div class="adr-code"><h3>Votre code adresse: '+adrCode+'</h3><i class="fa-regular fa-copy fa-xl copy"></i> <i id="close-popup" class="fa-solid fa-xmark fa-xl exit close-popup"></i></div>'
                });
                setTimeout(()=>{
                    document.querySelector(".close-popup")?.addEventListener("click",()=>{
                        mapview.current.popup.close();
                        setLocation(null);
                        pinLayer.current.removeAll();
                    });
                },100)
                setTimeout(()=>document.querySelector(".copy")?.addEventListener("click",async ()=>{
                    await navigator.clipboard.writeText(adrCode);
                    setCopiedToClipboard(true);
                    setTimeout(()=>{
                        setCopiedToClipboard(false);
                    },2000)
                }),0);
            }
        }
    },[location])
    return(<>
        <div className="map" id="map">
        </div>
        <div className="locate" id="locate"></div>
        <div className="search" id="search"></div> 
        <div className="zoom" id="zoom"></div>
        <div className="expand" id="expand"></div>
        {copiedToClipboard===true?<div className="copied-to-clipboard">Code adresse copié</div>:null}
        </>
    )  

}
export default MyMap;